import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrModalComponent } from './pr-modal/pr-modal.component';
import { PrModalConfirmComponent } from './pr-modal-confirm/pr-modal-confirm.component';
import { PrButtonModule } from '../pr-button/pr-button/pr-button.module';
import { PrIconModule } from '../pr-icon/pr-icon.module';

@NgModule({
  declarations: [PrModalComponent, PrModalConfirmComponent],
  imports: [CommonModule, PrIconModule, PrButtonModule],
  exports: [PrModalComponent, PrModalConfirmComponent],
})
export class PrModalModule {}
